import { Component } from '@angular/core'
import { Router } from '@angular/router'
import { of } from 'rxjs'
import { takeUntil, tap } from 'rxjs/operators'
import { onboardingStorageKeys } from 'src/app/constant'
import { Auth } from '../../../injectable'
import { UnsubscribeOnDestroy } from '../../../utility'

@Component({
    selector: 'app-authenticate',
    templateUrl: 'authenticate.html'
})
export class AuthenticateComponent extends UnsubscribeOnDestroy{

    constructor(
        private _auth: Auth,
        private _router: Router
    ) {
        super()

        const inviteCode = sessionStorage.getItem(onboardingStorageKeys.inviteCode)
        const assetId = sessionStorage.getItem(onboardingStorageKeys.inviteAsset)
        const role = sessionStorage.getItem(onboardingStorageKeys.inviteRole)
        const phoneNumber = sessionStorage.getItem(onboardingStorageKeys.inviteePhoneNumber)
        const signupTravelAgentRequest = sessionStorage.getItem(onboardingStorageKeys.signupTravelAgentRequest)
        const signupConsumerRequest = sessionStorage.getItem(onboardingStorageKeys.signupConsumerRequest)

        this._auth.authenticatedSubject
            .pipe(
                takeUntil(this.destroy$),
                tap(authenticated => {
                    console.log('AUTH: is authenticated - ', authenticated)

                    if (authenticated) {
                        console.log('AUTH: invite code - ', inviteCode)
                        console.log('AUTH: invite role - ', role)
                        console.log('AUTH: invite phone number - ', phoneNumber)

                        if (inviteCode && role && phoneNumber) {
                            of(this._router.navigateByUrl(`/accept-invitation/${inviteCode}?role=${role}&phone_number=${encodeURI(phoneNumber)}&asset=${assetId}`)).subscribe()
                        } 
                        else if (signupTravelAgentRequest) {
                            of(this._router.navigateByUrl(`/account-creation/${encodeURIComponent(signupTravelAgentRequest)}`)).subscribe()
                        } 
                        else if (signupConsumerRequest) {
                            of(this._router.navigateByUrl(`/consumer-account-creation/${encodeURIComponent(signupConsumerRequest)}`)).subscribe()
                        }
                        else {
                            of(this._router.navigateByUrl('/')).subscribe()
                        }
                    } else {
                        of(this._router.navigateByUrl('/onboarding')).subscribe()
                    }
                })
            ).subscribe()

        this._auth.authenticate()
    }
}